/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type DeliverableMetadataFragmentGQLType = (
  { __typename?: 'Deliverable' }
  & Pick<Types.DeliverableGQLType, 'id' | 'creditFacilityId' | 'creditFacilityName' | 'creditFacilitySlug' | 'deliverableType' | 'description' | 'dueDate' | 'name' | 'section' | 'status' | 'updated_at'>
  & { currentSubmission?: Types.Maybe<(
    { __typename?: 'DeliverableFileSubmission' }
    & Pick<Types.DeliverableFileSubmissionGQLType, 'fileName' | 'created_at'>
  ) | { __typename?: 'DeliverableValueSubmission' }>, expectedValueConfig: (
    { __typename?: 'DeliverableExpectedValueConfigNoSubmission' }
    & Pick<Types.DeliverableExpectedValueConfigNoSubmissionGQLType, 'valueType'>
  ) | (
    { __typename?: 'DeliverableExpectedValueConfigNonFile' }
    & Pick<Types.DeliverableExpectedValueConfigNonFileGQLType, 'valueType'>
  ) | (
    { __typename?: 'DeliverableExpectedValueConfigFile' }
    & Pick<Types.DeliverableExpectedValueConfigFileGQLType, 'valueType'>
  ) }
);

export type DeliverableFragmentGQLType = (
  { __typename?: 'Deliverable' }
  & Pick<Types.DeliverableGQLType, 'id' | 'configKey' | 'creditFacilityId' | 'creditFacilitySlug' | 'creditFacilityName' | 'name' | 'description' | 'dueDate' | 'status' | 'section' | 'updated_at' | 'created_at'>
  & { expectedValueConfig: (
    { __typename?: 'DeliverableExpectedValueConfigNoSubmission' }
    & Pick<Types.DeliverableExpectedValueConfigNoSubmissionGQLType, 'valueType'>
  ) | (
    { __typename?: 'DeliverableExpectedValueConfigNonFile' }
    & Pick<Types.DeliverableExpectedValueConfigNonFileGQLType, 'valueType'>
  ) | (
    { __typename?: 'DeliverableExpectedValueConfigFile' }
    & Pick<Types.DeliverableExpectedValueConfigFileGQLType, 'valueType' | 'fileTypes'>
  ), mostRecentVersion: (
    { __typename?: 'MostRecentDeliverableVersion' }
    & Pick<Types.MostRecentDeliverableVersionGQLType, 'isMostRecentDeliverableVersion' | 'mostRecentDeliverableId'>
  ) }
);

export type DeliverableFileSubmissionFragmentGQLType = (
  { __typename?: 'DeliverableFileSubmission' }
  & Pick<Types.DeliverableFileSubmissionGQLType, 'id' | 'deliverableId' | 'fileName' | 'value' | 'valueType' | 'created_at'>
);

export type DeliverableValueSubmissionFragmentGQLType = (
  { __typename?: 'DeliverableValueSubmission' }
  & Pick<Types.DeliverableValueSubmissionGQLType, 'id' | 'deliverableId' | 'value' | 'valueType' | 'created_at'>
);

export type DeliverableDependencyFragmentGQLType = (
  { __typename?: 'DeliverableDependency' }
  & { deliverable: (
    { __typename?: 'Deliverable' }
    & Pick<Types.DeliverableGQLType, 'id' | 'name' | 'dueDate' | 'status' | 'updated_at'>
    & { currentSubmission?: Types.Maybe<(
      { __typename?: 'DeliverableFileSubmission' }
      & DeliverableFileSubmissionFragmentGQLType
    ) | (
      { __typename?: 'DeliverableValueSubmission' }
      & DeliverableValueSubmissionFragmentGQLType
    )> }
  ) }
);

export type DeliverableResponsiblePartyFragmentGQLType = (
  { __typename?: 'DeliverableResponsibleParty' }
  & { responsibleParty: (
    { __typename?: 'Organization' }
    & Pick<Types.OrganizationGQLType, 'id' | 'name'>
  ) }
);

export type GetDeliverablesDeliverableDataFragmentGQLType = (
  { __typename?: 'Deliverable' }
  & Pick<Types.DeliverableGQLType, 'isDeliverableResponsibleParty' | 'isDeliverableDownloadPermissionedParty' | 'isDeliverableViewPermissionedParty'>
  & { responsibleParties: Array<(
    { __typename?: 'DeliverableResponsibleParty' }
    & { responsibleParty: (
      { __typename?: 'Organization' }
      & Pick<Types.OrganizationGQLType, 'id' | 'name'>
    ) }
  )>, dependencies: Array<(
    { __typename?: 'DeliverableDependency' }
    & DeliverableDependencyFragmentGQLType
  )> }
  & DeliverableMetadataFragmentGQLType
);

export type GetDeliverablesQueryVariablesGQLType = Types.Exact<{
  responsiblePartyId: Types.Scalars['UUID'];
  organizationId?: Types.Maybe<Types.Scalars['UUID']>;
  creditFacilityIds?: Types.Maybe<Array<Types.Scalars['UUID']> | Types.Scalars['UUID']>;
  limit?: Types.Maybe<Types.Scalars['Int']>;
  statuses?: Types.Maybe<Array<Types.DeliverableProgressStatusGQLType> | Types.DeliverableProgressStatusGQLType>;
  offset?: Types.Maybe<Types.Scalars['Int']>;
  startDate?: Types.Maybe<Types.Scalars['JSDate']>;
  endDate?: Types.Maybe<Types.Scalars['JSDate']>;
}>;


export type GetDeliverablesQueryGQLType = (
  { __typename?: 'Query' }
  & { deliverables: (
    { __typename?: 'DeliverablesConnection' }
    & Pick<Types.DeliverablesConnectionGQLType, 'totalCount'>
    & { nodes: Array<(
      { __typename?: 'Deliverable' }
      & GetDeliverablesDeliverableDataFragmentGQLType
    )>, offsetInfo: (
      { __typename?: 'OffsetInfo' }
      & Pick<Types.OffsetInfoGQLType, 'hasNextPage' | 'hasPreviousPage' | 'offset'>
    ) }
  ) }
);

export type GetDeliverableQueryVariablesGQLType = Types.Exact<{
  deliverableId: Types.Scalars['UUID'];
}>;


export type GetDeliverableQueryGQLType = (
  { __typename?: 'Query' }
  & { deliverable: (
    { __typename?: 'Deliverable' }
    & Pick<Types.DeliverableGQLType, 'creditAgreementDocumentId' | 'creditFacilityName' | 'isDeliverableResponsibleParty' | 'isDeliverableDownloadPermissionedParty' | 'isDeliverableViewPermissionedParty'>
    & { responsibleParties: Array<(
      { __typename?: 'DeliverableResponsibleParty' }
      & { responsibleParty: (
        { __typename?: 'Organization' }
        & Pick<Types.OrganizationGQLType, 'id' | 'name'>
      ) }
    )>, dependencies: Array<(
      { __typename?: 'DeliverableDependency' }
      & DeliverableDependencyFragmentGQLType
    )>, submissions: Array<(
      { __typename?: 'DeliverableFileSubmission' }
      & DeliverableFileSubmissionFragmentGQLType
    ) | (
      { __typename?: 'DeliverableValueSubmission' }
      & DeliverableValueSubmissionFragmentGQLType
    )>, currentSubmission?: Types.Maybe<(
      { __typename?: 'DeliverableFileSubmission' }
      & DeliverableFileSubmissionFragmentGQLType
    ) | (
      { __typename?: 'DeliverableValueSubmission' }
      & DeliverableValueSubmissionFragmentGQLType
    )>, events: Array<(
      { __typename?: 'EventWithActor' }
      & Pick<Types.EventWithActorGQLType, 'id' | 'actorName' | 'targetName' | 'domainKey' | 'actionKey' | 'created_at'>
      & { payload: { __typename?: 'FundingRequestPayload' } | { __typename?: 'FundingRequestComponentPayload' } | { __typename?: 'DeliverablesPayload' } | { __typename?: 'IngestionPayload' } | (
        { __typename?: 'InsertedDeliverablePayload' }
        & { deliverable: (
          { __typename?: 'DeliverablePayload' }
          & Pick<Types.DeliverablePayloadGQLType, 'name' | 'creditFacilityName'>
        ) }
      ) | (
        { __typename?: 'UpdatedDeliverableStatusPayload' }
        & Pick<Types.UpdatedDeliverableStatusPayloadGQLType, 'previousStatus'>
        & { deliverable: (
          { __typename?: 'DeliverablePayload' }
          & Pick<Types.DeliverablePayloadGQLType, 'status' | 'creditFacilityName'>
        ) }
      ) | (
        { __typename?: 'SubmittedDeliverableSubmissionPayload' }
        & { deliverable: (
          { __typename?: 'DeliverablePayload' }
          & Pick<Types.DeliverablePayloadGQLType, 'creditFacilityName'>
        ) }
      ) | { __typename?: 'VerificationPayload' } }
    )> }
    & DeliverableFragmentGQLType
  ) }
);

export type SubmitDeliverableSubmissionMutationVariablesGQLType = Types.Exact<{
  id: Types.Scalars['UUID'];
  deliverableId: Types.Scalars['UUID'];
  value: Types.Scalars['String'];
  valueType: Types.DeliverableValueTypeGQLType;
}>;


export type SubmitDeliverableSubmissionMutationGQLType = (
  { __typename?: 'Mutation' }
  & { submitDeliverableSubmission: (
    { __typename?: 'DeliverableFileSubmission' }
    & Pick<Types.DeliverableFileSubmissionGQLType, 'id' | 'value' | 'valueType'>
    & { deliverable: (
      { __typename?: 'Deliverable' }
      & Pick<Types.DeliverableGQLType, 'id' | 'name' | 'status' | 'dueDate'>
    ) }
  ) | (
    { __typename?: 'DeliverableValueSubmission' }
    & Pick<Types.DeliverableValueSubmissionGQLType, 'id' | 'value' | 'valueType'>
    & { deliverable: (
      { __typename?: 'Deliverable' }
      & Pick<Types.DeliverableGQLType, 'id' | 'name' | 'status' | 'dueDate'>
    ) }
  ) }
);

export type UpdateDeliverableStatusMutationVariablesGQLType = Types.Exact<{
  deliverableId: Types.Scalars['UUID'];
  status: Types.DeliverableProgressStatusGQLType;
}>;


export type UpdateDeliverableStatusMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateDeliverableStatus: (
    { __typename?: 'Deliverable' }
    & Pick<Types.DeliverableGQLType, 'id' | 'status' | 'name'>
  ) }
);

export type GetDeliverableSubmissionDownloadUrlQueryVariablesGQLType = Types.Exact<{
  deliverableSubmissionId: Types.Scalars['UUID'];
  deliverableId: Types.Scalars['UUID'];
}>;


export type GetDeliverableSubmissionDownloadUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { deliverable: (
    { __typename?: 'Deliverable' }
    & Pick<Types.DeliverableGQLType, 'id' | 'status'>
    & { submissions: Array<(
      { __typename?: 'DeliverableFileSubmission' }
      & Pick<Types.DeliverableFileSubmissionGQLType, 'submissionDownloadUrl'>
    ) | { __typename?: 'DeliverableValueSubmission' }> }
  ) }
);

export type GetCurrentDeliverableSubmissionDownloadUrlQueryVariablesGQLType = Types.Exact<{
  deliverableId: Types.Scalars['UUID'];
}>;


export type GetCurrentDeliverableSubmissionDownloadUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { deliverable: (
    { __typename?: 'Deliverable' }
    & Pick<Types.DeliverableGQLType, 'id' | 'status'>
    & { currentSubmission?: Types.Maybe<(
      { __typename?: 'DeliverableFileSubmission' }
      & Pick<Types.DeliverableFileSubmissionGQLType, 'submissionDownloadUrl'>
    ) | { __typename?: 'DeliverableValueSubmission' }> }
  ) }
);

export const DeliverableFragmentDocGQLType = gql`
    fragment Deliverable on Deliverable {
  id
  configKey
  creditFacilityId
  creditFacilitySlug
  creditFacilityName
  expectedValueConfig {
    ... on DeliverableExpectedValueConfigNoSubmission {
      valueType
    }
    ... on DeliverableExpectedValueConfigNonFile {
      valueType
    }
    ... on DeliverableExpectedValueConfigFile {
      valueType
      fileTypes
    }
  }
  name
  description
  dueDate
  status
  section
  updated_at
  created_at
  mostRecentVersion {
    isMostRecentDeliverableVersion
    mostRecentDeliverableId
  }
}
    `;
export const DeliverableResponsiblePartyFragmentDocGQLType = gql`
    fragment DeliverableResponsibleParty on DeliverableResponsibleParty {
  responsibleParty {
    id
    name
  }
}
    `;
export const DeliverableMetadataFragmentDocGQLType = gql`
    fragment DeliverableMetadata on Deliverable {
  id
  creditFacilityId
  creditFacilityName
  creditFacilitySlug
  currentSubmission {
    ... on DeliverableFileSubmission {
      fileName
      created_at
    }
  }
  deliverableType
  description
  dueDate
  expectedValueConfig {
    ... on DeliverableExpectedValueConfigNoSubmission {
      valueType
    }
    ... on DeliverableExpectedValueConfigNonFile {
      valueType
    }
    ... on DeliverableExpectedValueConfigFile {
      valueType
    }
  }
  name
  section
  status
  updated_at
}
    `;
export const DeliverableFileSubmissionFragmentDocGQLType = gql`
    fragment DeliverableFileSubmission on DeliverableFileSubmission {
  id
  deliverableId
  fileName
  value
  valueType
  created_at
}
    `;
export const DeliverableValueSubmissionFragmentDocGQLType = gql`
    fragment DeliverableValueSubmission on DeliverableValueSubmission {
  id
  deliverableId
  value
  valueType
  created_at
}
    `;
export const DeliverableDependencyFragmentDocGQLType = gql`
    fragment DeliverableDependency on DeliverableDependency {
  deliverable {
    id
    name
    dueDate
    status
    currentSubmission {
      ... on DeliverableFileSubmission {
        ...DeliverableFileSubmission
      }
      ... on DeliverableValueSubmission {
        ...DeliverableValueSubmission
      }
    }
    updated_at
  }
}
    ${DeliverableFileSubmissionFragmentDocGQLType}
${DeliverableValueSubmissionFragmentDocGQLType}`;
export const GetDeliverablesDeliverableDataFragmentDocGQLType = gql`
    fragment GetDeliverablesDeliverableData on Deliverable {
  ...DeliverableMetadata
  isDeliverableResponsibleParty
  isDeliverableDownloadPermissionedParty
  isDeliverableViewPermissionedParty
  responsibleParties {
    responsibleParty {
      id
      name
    }
  }
  dependencies {
    ...DeliverableDependency
  }
}
    ${DeliverableMetadataFragmentDocGQLType}
${DeliverableDependencyFragmentDocGQLType}`;
export const GetDeliverablesDocumentGQLType = gql`
    query GetDeliverables($responsiblePartyId: UUID!, $organizationId: UUID, $creditFacilityIds: [UUID!], $limit: Int, $statuses: [DeliverableProgressStatus!], $offset: Int, $startDate: JSDate, $endDate: JSDate) {
  deliverables(
    responsiblePartyId: $responsiblePartyId
    organizationId: $organizationId
    creditFacilityIds: $creditFacilityIds
    limit: $limit
    statuses: $statuses
    offset: $offset
    startDate: $startDate
    endDate: $endDate
  ) {
    nodes {
      ...GetDeliverablesDeliverableData
    }
    offsetInfo {
      hasNextPage
      hasPreviousPage
      offset
    }
    totalCount
  }
}
    ${GetDeliverablesDeliverableDataFragmentDocGQLType}`;

/**
 * __useGetDeliverablesQuery__
 *
 * To run a query within a React component, call `useGetDeliverablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliverablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliverablesQuery({
 *   variables: {
 *      responsiblePartyId: // value for 'responsiblePartyId'
 *      organizationId: // value for 'organizationId'
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      limit: // value for 'limit'
 *      statuses: // value for 'statuses'
 *      offset: // value for 'offset'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDeliverablesQuery(baseOptions: Apollo.QueryHookOptions<GetDeliverablesQueryGQLType, GetDeliverablesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliverablesQueryGQLType, GetDeliverablesQueryVariablesGQLType>(GetDeliverablesDocumentGQLType, options);
      }
export function useGetDeliverablesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliverablesQueryGQLType, GetDeliverablesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliverablesQueryGQLType, GetDeliverablesQueryVariablesGQLType>(GetDeliverablesDocumentGQLType, options);
        }
export type GetDeliverablesQueryHookResult = ReturnType<typeof useGetDeliverablesQuery>;
export type GetDeliverablesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDeliverablesLazyQueryGQLType>;
export type GetDeliverablesQueryResultGQLType = Apollo.QueryResult<GetDeliverablesQueryGQLType, GetDeliverablesQueryVariablesGQLType>;
export const GetDeliverableDocumentGQLType = gql`
    query GetDeliverable($deliverableId: UUID!) {
  deliverable(deliverableId: $deliverableId) {
    ...Deliverable
    creditAgreementDocumentId
    creditFacilityName
    isDeliverableResponsibleParty
    isDeliverableDownloadPermissionedParty
    isDeliverableViewPermissionedParty
    responsibleParties {
      responsibleParty {
        id
        name
      }
    }
    dependencies {
      ...DeliverableDependency
    }
    submissions {
      ... on DeliverableFileSubmission {
        ...DeliverableFileSubmission
      }
      ... on DeliverableValueSubmission {
        ...DeliverableValueSubmission
      }
    }
    currentSubmission {
      ... on DeliverableFileSubmission {
        ...DeliverableFileSubmission
      }
      ... on DeliverableValueSubmission {
        ...DeliverableValueSubmission
      }
    }
    events {
      id
      actorName
      targetName
      domainKey
      actionKey
      created_at
      payload {
        ... on InsertedDeliverablePayload {
          deliverable {
            name
            creditFacilityName
          }
        }
        ... on UpdatedDeliverableStatusPayload {
          previousStatus
          deliverable {
            status
            creditFacilityName
          }
        }
        ... on SubmittedDeliverableSubmissionPayload {
          deliverable {
            creditFacilityName
          }
        }
      }
    }
  }
}
    ${DeliverableFragmentDocGQLType}
${DeliverableDependencyFragmentDocGQLType}
${DeliverableFileSubmissionFragmentDocGQLType}
${DeliverableValueSubmissionFragmentDocGQLType}`;

/**
 * __useGetDeliverableQuery__
 *
 * To run a query within a React component, call `useGetDeliverableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliverableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliverableQuery({
 *   variables: {
 *      deliverableId: // value for 'deliverableId'
 *   },
 * });
 */
export function useGetDeliverableQuery(baseOptions: Apollo.QueryHookOptions<GetDeliverableQueryGQLType, GetDeliverableQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliverableQueryGQLType, GetDeliverableQueryVariablesGQLType>(GetDeliverableDocumentGQLType, options);
      }
export function useGetDeliverableLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliverableQueryGQLType, GetDeliverableQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliverableQueryGQLType, GetDeliverableQueryVariablesGQLType>(GetDeliverableDocumentGQLType, options);
        }
export type GetDeliverableQueryHookResult = ReturnType<typeof useGetDeliverableQuery>;
export type GetDeliverableLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDeliverableLazyQueryGQLType>;
export type GetDeliverableQueryResultGQLType = Apollo.QueryResult<GetDeliverableQueryGQLType, GetDeliverableQueryVariablesGQLType>;
export const SubmitDeliverableSubmissionDocumentGQLType = gql`
    mutation SubmitDeliverableSubmission($id: UUID!, $deliverableId: UUID!, $value: String!, $valueType: DeliverableValueType!) {
  submitDeliverableSubmission(
    id: $id
    deliverableId: $deliverableId
    value: $value
    valueType: $valueType
  ) {
    ... on DeliverableFileSubmission {
      id
      value
      valueType
      deliverable {
        id
        name
        status
        dueDate
      }
    }
    ... on DeliverableValueSubmission {
      id
      value
      valueType
      deliverable {
        id
        name
        status
        dueDate
      }
    }
  }
}
    `;
export type SubmitDeliverableSubmissionMutationFnGQLType = Apollo.MutationFunction<SubmitDeliverableSubmissionMutationGQLType, SubmitDeliverableSubmissionMutationVariablesGQLType>;

/**
 * __useSubmitDeliverableSubmissionMutation__
 *
 * To run a mutation, you first call `useSubmitDeliverableSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitDeliverableSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitDeliverableSubmissionMutation, { data, loading, error }] = useSubmitDeliverableSubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deliverableId: // value for 'deliverableId'
 *      value: // value for 'value'
 *      valueType: // value for 'valueType'
 *   },
 * });
 */
export function useSubmitDeliverableSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<SubmitDeliverableSubmissionMutationGQLType, SubmitDeliverableSubmissionMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitDeliverableSubmissionMutationGQLType, SubmitDeliverableSubmissionMutationVariablesGQLType>(SubmitDeliverableSubmissionDocumentGQLType, options);
      }
export type SubmitDeliverableSubmissionMutationHookResult = ReturnType<typeof useSubmitDeliverableSubmissionMutation>;
export type SubmitDeliverableSubmissionMutationResultGQLType = Apollo.MutationResult<SubmitDeliverableSubmissionMutationGQLType>;
export type SubmitDeliverableSubmissionMutationOptionsGQLType = Apollo.BaseMutationOptions<SubmitDeliverableSubmissionMutationGQLType, SubmitDeliverableSubmissionMutationVariablesGQLType>;
export const UpdateDeliverableStatusDocumentGQLType = gql`
    mutation UpdateDeliverableStatus($deliverableId: UUID!, $status: DeliverableProgressStatus!) {
  updateDeliverableStatus(deliverableId: $deliverableId, status: $status) {
    id
    status
    name
  }
}
    `;
export type UpdateDeliverableStatusMutationFnGQLType = Apollo.MutationFunction<UpdateDeliverableStatusMutationGQLType, UpdateDeliverableStatusMutationVariablesGQLType>;

/**
 * __useUpdateDeliverableStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDeliverableStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliverableStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliverableStatusMutation, { data, loading, error }] = useUpdateDeliverableStatusMutation({
 *   variables: {
 *      deliverableId: // value for 'deliverableId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateDeliverableStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliverableStatusMutationGQLType, UpdateDeliverableStatusMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliverableStatusMutationGQLType, UpdateDeliverableStatusMutationVariablesGQLType>(UpdateDeliverableStatusDocumentGQLType, options);
      }
export type UpdateDeliverableStatusMutationHookResult = ReturnType<typeof useUpdateDeliverableStatusMutation>;
export type UpdateDeliverableStatusMutationResultGQLType = Apollo.MutationResult<UpdateDeliverableStatusMutationGQLType>;
export type UpdateDeliverableStatusMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateDeliverableStatusMutationGQLType, UpdateDeliverableStatusMutationVariablesGQLType>;
export const GetDeliverableSubmissionDownloadUrlDocumentGQLType = gql`
    query GetDeliverableSubmissionDownloadUrl($deliverableSubmissionId: UUID!, $deliverableId: UUID!) {
  deliverable(deliverableId: $deliverableId) {
    id
    status
    submissions(deliverableSubmissionId: $deliverableSubmissionId) {
      ... on DeliverableFileSubmission {
        submissionDownloadUrl
      }
    }
  }
}
    `;

/**
 * __useGetDeliverableSubmissionDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetDeliverableSubmissionDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliverableSubmissionDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliverableSubmissionDownloadUrlQuery({
 *   variables: {
 *      deliverableSubmissionId: // value for 'deliverableSubmissionId'
 *      deliverableId: // value for 'deliverableId'
 *   },
 * });
 */
export function useGetDeliverableSubmissionDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDeliverableSubmissionDownloadUrlQueryGQLType, GetDeliverableSubmissionDownloadUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliverableSubmissionDownloadUrlQueryGQLType, GetDeliverableSubmissionDownloadUrlQueryVariablesGQLType>(GetDeliverableSubmissionDownloadUrlDocumentGQLType, options);
      }
export function useGetDeliverableSubmissionDownloadUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliverableSubmissionDownloadUrlQueryGQLType, GetDeliverableSubmissionDownloadUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliverableSubmissionDownloadUrlQueryGQLType, GetDeliverableSubmissionDownloadUrlQueryVariablesGQLType>(GetDeliverableSubmissionDownloadUrlDocumentGQLType, options);
        }
export type GetDeliverableSubmissionDownloadUrlQueryHookResult = ReturnType<typeof useGetDeliverableSubmissionDownloadUrlQuery>;
export type GetDeliverableSubmissionDownloadUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDeliverableSubmissionDownloadUrlLazyQueryGQLType>;
export type GetDeliverableSubmissionDownloadUrlQueryResultGQLType = Apollo.QueryResult<GetDeliverableSubmissionDownloadUrlQueryGQLType, GetDeliverableSubmissionDownloadUrlQueryVariablesGQLType>;
export const GetCurrentDeliverableSubmissionDownloadUrlDocumentGQLType = gql`
    query GetCurrentDeliverableSubmissionDownloadUrl($deliverableId: UUID!) {
  deliverable(deliverableId: $deliverableId) {
    id
    status
    currentSubmission {
      ... on DeliverableFileSubmission {
        submissionDownloadUrl
      }
    }
  }
}
    `;

/**
 * __useGetCurrentDeliverableSubmissionDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetCurrentDeliverableSubmissionDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentDeliverableSubmissionDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentDeliverableSubmissionDownloadUrlQuery({
 *   variables: {
 *      deliverableId: // value for 'deliverableId'
 *   },
 * });
 */
export function useGetCurrentDeliverableSubmissionDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentDeliverableSubmissionDownloadUrlQueryGQLType, GetCurrentDeliverableSubmissionDownloadUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentDeliverableSubmissionDownloadUrlQueryGQLType, GetCurrentDeliverableSubmissionDownloadUrlQueryVariablesGQLType>(GetCurrentDeliverableSubmissionDownloadUrlDocumentGQLType, options);
      }
export function useGetCurrentDeliverableSubmissionDownloadUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentDeliverableSubmissionDownloadUrlQueryGQLType, GetCurrentDeliverableSubmissionDownloadUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentDeliverableSubmissionDownloadUrlQueryGQLType, GetCurrentDeliverableSubmissionDownloadUrlQueryVariablesGQLType>(GetCurrentDeliverableSubmissionDownloadUrlDocumentGQLType, options);
        }
export type GetCurrentDeliverableSubmissionDownloadUrlQueryHookResult = ReturnType<typeof useGetCurrentDeliverableSubmissionDownloadUrlQuery>;
export type GetCurrentDeliverableSubmissionDownloadUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCurrentDeliverableSubmissionDownloadUrlLazyQueryGQLType>;
export type GetCurrentDeliverableSubmissionDownloadUrlQueryResultGQLType = Apollo.QueryResult<GetCurrentDeliverableSubmissionDownloadUrlQueryGQLType, GetCurrentDeliverableSubmissionDownloadUrlQueryVariablesGQLType>;